export enum OpportunitySearchOrderingEnum {
    NAME = 'NAME',
    NEXT_ACTIVITY = 'NEXT_ACTIVITY',
    SOURCE = 'SOURCE',
    RESPONSIBLE = 'RESPONSIBLE',
    CREATION_DATE = 'CREATION_DATE',
}
